<mat-progress-bar *ngIf="loading" mode="indeterminate"/>
<h2 mat-dialog-title class="m-b-20">
  Con quale CER intendi accedere?
</h2>
<mat-dialog-content>
  <ngx-skeleton-loader *ngIf="loading; else showForm" [count]="6" />


  <ng-template #showForm>
    <form [formGroup]="form" (ngSubmit)="submit()" class="p-10">

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Imposta CER</mat-label>
        <mat-select formControlName="cer">
          <mat-option [value]="">Seleziona un valore</mat-option>
          <mat-option *ngFor="let cer of cerList" [value]="cer.id">
            {{cer.name}}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix color="primary">
          <i-tabler name="building-store"/>
        </mat-icon>
      </mat-form-field>     

      <button [disabled]="form.invalid" mat-flat-button color="primary" style="float:right;" class="m-x-4">
        <mat-icon>save</mat-icon>
        Salva e continua
      </button>

    </form>
  </ng-template>
</mat-dialog-content>
